<template>
    <v-menu
        offset-y
        :close-on-content-click="false"
        min-width = "1000"
        max-width="1000"
        v-if      = "preferences && user"
        v-model   = "menu"
        style     = "z-index: 10"
    >
        <template v-slot:activator="{ on, attrs }">
            <div class="nav-dropdown" v-bind="attrs" v-on="on">
                <div class="mr-2 mt-1">{{ user.firstname }} {{ user.lastname }}</div>
                <v-avatar
                    color="primary"
                    size="30">
                    <span class="white--text nav-avatar">{{ avatar }}</span>
                </v-avatar>
                <div class="mt-1 ml-1"><i class="nav-icon fas fa-caret-down"></i></div>
            </div>
        </template>

        <v-card>
            <v-row class="no-frame">
                <v-col class="col-5">
                    <div style="padding: 10px; border-style: solid; border-width: 1px; border-color: lightgrey; border-radius: 10px; height: 100%">
                        <div class="no-frame mt-3" style="justify-content: center">
                            <div class="profile-avatar primary">
                                {{ avatar }}
                            </div>
                        </div>
                        <div class="v-flex mt-3">
                            <v-select
                                v-model="preferences.theme"
                                :items="themes"
                                item-value="name"
                                item-text="name"
                                @change="onTheme"
                                :label="$t('nav.user.appearance')"
                            >
                                <template slot="item" slot-scope="data">
                                    <div class="v-flex">
                                        <div class="theme-preview" :style="'background: ' + data.item.primary"> </div>
                                        <div class="ml-2">{{data.item.name}}</div>
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        <div class="mt-0 mr-5" style="font-size: 11pt">
                            <div class="primary--text" style="font-weight: 800">
                                {{ $t('nav.user.user') }}
                            </div>
                            <div>
                                - {{ profile.username }}
                            </div>
                            <div>
                                - {{ profile.name }}
                            </div>
                            <div>
                                - {{ profile.email }}
                            </div>
                            <div class="primary--text mt-5" style="font-weight: 800">
                                {{ $t('nav.user.roles') }}
                            </div>
                            <div style="overflow-y: auto; max-height: 400px;">
                                <div v-for="(role, index) in profile.roles" :key="index">
                                    - {{ role }}
                                </div>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col class="col-7 pl-0">
                    <div style="padding: 10px; border-style: solid; border-width: 1px; border-color: lightgrey; border-radius: 10px; width: 100%; height: 100%;">
                        <v-tabs
                            v-model="tab"
                            :show-arrows = "false"
                            grow
                        >
                            <v-tabs-slider color="primary"></v-tabs-slider>

                            <v-tab href="#tab-customer" class="user-tab">
                                Kunden
                            </v-tab>

                            <v-tab href="#tab-preferences" class="user-tab">
                                Einstellungen
                            </v-tab>

                            <v-tab href="#tab-signature" v-if="liftmanager" class="user-tab">
                                Stempel
                            </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">
                            <v-tab-item value="tab-customer">
                                <nav-user-customer />
                            </v-tab-item>

                            <v-tab-item value="tab-preferences">
                                <nav-user-preferences />
                            </v-tab-item>

                            <v-tab-item value="tab-signature">
                                <nav-user-stamp />
                            </v-tab-item>
                        </v-tabs-items>
                        <div>
                            <v-btn
                                class="logout-button"
                                color="primary"
                                @click="logout"
                                style="margin-top: 0"
                            >
                                {{ $t("nav.user.logout") }}
                            </v-btn>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-card>
    </v-menu>
</template>

<script>

import security              from "@/main"
import Core                  from "@/modules/core/service/Core.js";
import NavUserPreferences    from "@/modules/msd/user/components/nav/NavUserPreferences";
import NavUserCustomer       from "@/modules/msd/user/components/nav/NavUserCustomer";
import NavUserStamp          from "@/modules/msd/user/components/nav/NavUserStamp";

export default {
    name: "NavUserMenu",
    components: {
        NavUserStamp,
        NavUserCustomer,
        NavUserPreferences
    },

    data: () => ({
        menu: false,
        tab: null,
    }),

    computed: {
        admin () {
            return Core.role.admin();
        },

        liftmanager () {
            return Core.role.liftmanager();
        },

        privileged () {
            return Core.role.privileged();
        },

        preferences () {
            return this.$store.getters.preferences;
        },

        themes () {
            return this.$store.getters.themes;
        },

        user () {
            return this.preferences.user;
        },

        profile () {
          return security.profile();
        },

        avatar () {
            if (this.user && this.user.firstname && this.user.lastname) {
                return this.user.firstname.substring(0,1) + this.user.lastname.substring(0,1);
            }
            return this.profile.avatar;
        }
    },

    methods: {
        logout() {
            security.logout();
        },

        onTheme (name) {
            const theme = this.themes.find(t => t.name === name);
            this.$vuetify.theme.themes.light.primary = theme.primary;
            this.preferences.theme = name;
            Core.preferences.store(this, this.preferences);
        },

        onClose () {
            this.menu = false;
        }
    }
}
</script>

<style scoped>

.nav-dropdown{
    padding-left: 2px;
    padding-top: 0;
    height: 32px;
    text-align: left;
    font-size: 11pt;
    margin-left: 15px;
    display: flex;
    font-weight: 500;
    justify-content: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.nav-icon {
    font-size: 12pt!important;
}

.nav-avatar {
  font-size: 9pt;
}

.profile-avatar {
    width: 200px;
    height: 200px;
    color: white;
    font-size: 50pt;
    text-align: center;
    padding-top: 17%;
    border-radius: 50%;
    margin-left: 55px;
    margin-right: 20px;
}

.theme-preview {
    width: 25px;
    height: 25px;
    border-radius: 50%;
}

.logout-button {
    text-align: center;
    margin-left: calc(50% - 75px);
    width: 150px;
    margin-top: calc(15% - 35px);
}

::v-deep .v-tab {
    text-transform: none;
    letter-spacing: unset;
    font-size: 12pt!important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: lightgray;
    width: 100%;
}

::v-deep .nav-user-tab-item {
    padding-left: 10px;
    padding-top: 30px;
    height: 600px;
}

.user-tab {
    width: 110px;
}

</style>